import { render, staticRenderFns } from "./CruiseDetailCommenTitle.vue?vue&type=template&id=b37f59ba&scoped=true&"
import script from "./CruiseDetailCommenTitle.vue?vue&type=script&lang=js&"
export * from "./CruiseDetailCommenTitle.vue?vue&type=script&lang=js&"
import style0 from "./CruiseDetailCommenTitle.vue?vue&type=style&index=0&id=b37f59ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b37f59ba",
  null
  
)

export default component.exports